import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { Currency } from '@wdx/shared/swagger-gen';

@Injectable({ providedIn: 'root' })
export class CurrencyApiService extends BaseApiService {
    getCunrrencies(): Observable<Currency[]> {
        return this._get<Currency[]>('currency/nonpaged');
    }
}
